import Companies from "../pages/filters/Companies";

export default [
    {
        name: 'home',
        path: '/',
    },
    {
        name: 'companies',
        path: '/equipes-artistiques',
        component: Companies,
    },
]